import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import employee from '../class/employee';
import { isWsBusy, onWsIdle } from '../class/wsActivity';

// Logout automatico dopo un periodo di inattività: i terminali di reparto
// restano incustoditi, la sessione va chiusa da sola.
const INACTIVITY_MS = 60 * 1000;
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

export default function useInactivityLogout() {
    const navigate = useNavigate();
    const timerRef = useRef(null);

    useEffect(() => {
        // Function declaration (hoisted): doLogout e reset si riferiscono a vicenda.
        function doLogout() {
            // Chiamata WS in corso (può allungarsi al crescere del DB): rimanda,
            // così non si slogga l'utente a metà di un'operazione.
            if (isWsBusy()) {
                reset();
                return;
            }
            const emp = new employee();
            // Agisci solo se c'è una sessione: evita redirect inutili sul login.
            if (emp.token) {
                emp.logout();
                navigate('/login');
            }
        }

        function reset() {
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(doLogout, INACTIVITY_MS);
        }

        ACTIVITY_EVENTS.forEach(ev => window.addEventListener(ev, reset, { passive: true }));
        // Il completamento di una chiamata WS conta come attività: riparte da adesso.
        const unsubscribeWsIdle = onWsIdle(reset);
        reset();

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            ACTIVITY_EVENTS.forEach(ev => window.removeEventListener(ev, reset));
            unsubscribeWsIdle();
        };
    }, [navigate]);
}
